/** Lowercase and strip accents, so `País` matches `pais`. */
export function foldText(s: string): string {
  return s
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "") // combining marks left by NFD
    .toLowerCase();
}
